/**
 * Labstep
 *
 * @module components/EntityUser/Action/Manage
 * @desc   Manage collaborators
 */

import { Can } from 'labstep-web/components/Entity/Can';
import { Action } from 'labstep-web/components/Entity/Can/types';
import { EntityUserManager } from 'labstep-web/components/EntityUser/Manager';
import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type { EntityUserActionManageProps } from './types';

export const EntityUserActionManage: React.FC<
  EntityUserActionManageProps
> = ({ entity, ...rest }) => (
  <ModalDefault
    viewComponent={({ toggleModal }) => (
      <Can
        entityName={entity.entityName}
        id={entity.idAttr}
        action={Action.assign}
      >
        <ActionComponent
          dataCy="components/EntityUser/Action/Manage"
          type="option"
          text={'Manage Collaborators'}
          icon={ICONS.entity.actions.assign}
          onClick={toggleModal}
        />
      </Can>
    )}
    {...rest}
    showDone
    header="Manage Collaborators"
    content={<EntityUserManager entity={entity} />}
  />
);
